import { server } from "../api";
import axios from "axios";

// Read-only discovery of WVP's registered GB28181 devices/channels, backing the
// edit-modal picker so an operator selects a real device/channel instead of
// hand-typing a 20-digit national-standard code. The backend already trims the
// WVP payloads and returns [] on any WVP failure; we mirror that here so a
// network error surfaces as an empty list the caller can fall back from.

const ListDevices = async () => {
  const response = await axios.get(`${server}v1/streaming/gb28181/devices`);
  return response.data?.devices ?? [];
};

// The saved gb28181_channel_id is a channel's own national code, exposed by the
// backend as `channelId` (WVP keeps it in a field named `deviceId`).
const ListChannels = async (deviceId) => {
  const response = await axios.get(
    `${server}v1/streaming/gb28181/devices/${encodeURIComponent(
      deviceId,
    )}/channels`,
  );
  return response.data?.channels ?? [];
};

export default { ListDevices, ListChannels };
